module.exports = __webpack_public_path__ + "img/skinsback.bbe6429b.svg";